import { useMutation } from '@apollo/client';
import { connectEsigningProvider } from './mutation';
export const useConnectEsigningProvider = () => {
    const [mutate, { loading, error, data }] = useMutation(connectEsigningProvider);
    const handleMutate = (providerId) => {
        mutate({ variables: { providerId } });
    };
    return { mutate: handleMutate, loading, error, data };
};
